import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { PermissionResponse } from '../core/base-api';
import { Routes } from '@angular/router';
import { GrundbuchgeschaeftRoutes } from './grundbuchgeschaeft/grundbuchgeschaeft.routes';
import { RechtRoutes } from './recht/recht.routes';
import { PersonRoutes } from '../stammdaten/person-stamm/personstamm.routes';
import { PersonGbRoutes } from './person-gb/persongb.routes';
import { GrundbuchmeldungRoutes } from './grundbuchmeldung/grundbuchmeldung.routes';
import { AlteGrundbuchmeldungRoutes } from './alte-grundbuchmeldung/alte-grundbuchmeldung.routes';
import { Ech0134Routes } from '../ech0134/ech0134.routes';
import { PublikationRoutes } from './publikation/publikation.routes';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

export const GrundbuchRoutes: Routes = [
  {
    path: 'grundbuch',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN]
    },
    children: [
      ...GrundbuchgeschaeftRoutes,
      ...RechtRoutes,
      ...PersonRoutes,
      ...PersonGbRoutes,
      ...GrundbuchmeldungRoutes,
      ...AlteGrundbuchmeldungRoutes,
      ...Ech0134Routes,
      ...PublikationRoutes
    ]
  }
];
